export interface ReportState {
  balanceSheet: any[];
  error: string;
  loader: boolean;
}
export const INITIALSTATE: ReportState = {
  balanceSheet: null,
  error: null,
  loader: null,
};
